import React from 'react';
import { Box, useTheme } from '@mui/material';
import { SnippetHistory } from '../components';

function MySnippets() {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
      <Box sx={{
          width: '100%',
          minHeight: '100vh',
          backgroundColor: isDark ? '#0F172A' : theme.palette.background.default,
          p: 1.5
        }}>
      <SnippetHistory />
    </Box>
  );
}

export default MySnippets;
